import BaseScreen from './_base';

export default function CreateReportScreen() {
  return <BaseScreen title="Create Report" description="Report builder flow." />;
}
